/**
 * ------------------------------------------------------------
 * Featured Collections
 * IndianVastraa Premium Theme
 * ------------------------------------------------------------
 */

(() => {

    "use strict";

    const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches;

    const sections = document.querySelectorAll(".featured-collections");

    if (!sections.length) return;

    /*==========================================================
      Reveal Animation
    ==========================================================*/

    if ("IntersectionObserver" in window && !reduceMotion) {

        const observer = new IntersectionObserver((entries) => {

            entries.forEach((entry) => {

                if (!entry.isIntersecting) return;

                entry.target.classList.add("is-visible");

                observer.unobserve(entry.target);

            });

        }, {

            threshold: 0.18,
            rootMargin: "0px 0px -80px 0px"

        });

        sections.forEach((section) => observer.observe(section));

    } else {

        sections.forEach((section) => {

            section.classList.add("is-visible");

        });

    }

    /*==========================================================
      Luxury Mouse Tilt
    ==========================================================*/

    if (reduceMotion) return;

    document.querySelectorAll(".fc-card").forEach((card) => {

        const image = card.querySelector(".fc-card__image-wrapper");

        if (!image) return;

        let frame = null;

        card.addEventListener("mousemove", (event) => {

            if (frame) cancelAnimationFrame(frame);

            frame = requestAnimationFrame(() => {

                const rect = image.getBoundingClientRect();

                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;

                const rotateY = ((x / rect.width) - 0.5) * 6;
                const rotateX = ((0.5 - (y / rect.height))) * 6;

                image.style.transform = `
                    perspective(900px)
                    rotateX(${rotateX}deg)
                    rotateY(${rotateY}deg)
                    translateY(-8px)
                `;

            });

        });

        card.addEventListener("mouseleave", () => {

            image.style.transform = "";

        });

    });

})();